// extracted by mini-css-extract-plugin
export default {"responsiveContainer":"YoutubeVideo_responsiveContainer__aDvGa"};